<template>
  <div class="home">
    <div ref="fullpage" id="fullpage">
      <div class="section page-1">
          <div class="welcome">
            <img src="@/assets/image/logo.png" />
            <div class="footer">
              <div class="_title">皇太后餐點管理系統</div>
            </div>
          </div>
      </div>
      <div class="section page-2">
        <div class="box">
          <div class="_logo"><img src="@/assets/image/logo1.png" /></div>
          <div class="_welcome">
            <div class="_t1">您好，歡迎使用</div>
            <div class="_t2">皇太后頂級月子膳食<span class="_br">餐飲管理系統</span></div>
          </div>
        </div>
      </div>
      <div class="section page-2 page-3">
        <div class="box">
          <div class="_logo"><img src="@/assets/image/logo1.png" /></div>
          <div class="_login">
            <el-form ref="loginForm" :model="loginForm" class="login-form" autocomplete="on" label-position="left">
              <div class="item-box">
                <div class="title-container">
                  <h3 class="title">
                    系統登入
                  </h3>
                </div>
                <div class="user-container">
                  <el-form-item prop="username">
                    <div slot="label" class="custom-label">
                      <span>帳號</span>
                      <small>User ID</small>
                    </div>
                    <el-input
                        ref="username"
                        v-model="loginForm.account"
                        placeholder=""
                        name="username"
                        type="text"
                        tabindex="1"
                        autocomplete="off"
                    />
                  </el-form-item>

                  <el-tooltip v-model="capsTooltip" content="1" placement="right" manual>
                    <el-form-item prop="password">
                      <div slot="label" class="custom-label">
                        <span>密碼</span>
                        <small>Password</small>
                      </div>
                      <el-input
                          :key="passwordType"
                          ref="password"
                          v-model="loginForm.password"
                          :type="passwordType"
                          placeholder=""
                          name="password"
                          tabindex="2"
                          autocomplete="off"
                          @keyup.native="checkCapslock"
                          @blur="capsTooltip = false"
                          @keyup.enter.native="handleLogin"
                          show-password
                      />
                      <!-- <span class="show-pwd"  @click="showPwd">
                   <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
                  </span> -->
                    </el-form-item>
                  </el-tooltip>

                  <div class="remember">
                    <el-checkbox v-model="checked">記住我，下次快速登入</el-checkbox>
                  </div>
                </div>

              </div>
              <el-button :loading="loading" type="primary"  @click="handleLogin">
                登入
              </el-button>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!--停機公告彈框-->
    <el-dialog
        custom-class="custom-popup animate"
        :visible.sync="informationVisible"
        width="40%">
      <transition
          enter-active-class="animate__animated animate__zoomIn"
          leave-active-class="animate__animated animate__zoomOut"
      >
        <div class="custom-popup-box" v-show="informationVisible">
          <div class="close" @click="informationVisible = false"></div>
          <div class="_header">停機公告</div>
          <div class="_body">
            <p>茲因本公司辦理系統升級作業，將於<br />111年5月2日（一）01:00-04:00暫停下列服務：<br/>媽媽選菜/加餐/停餐/換房/編輯客戶資料。</p>
            <p>如您有餐點上的安排或異動需求，請您避開該時段。造成您的不便，尚祈見諒！</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p style="text-align: right;">皇太后頂級月子膳食</p>
          </div>
          <div class="_footer">
            <button class="el-button" @click="informationVisible = false">我知道了</button>
          </div>
        </div>
      </transition>
    </el-dialog>
    <div class="box">
      <el-button @click="activeObserveshow = !activeObserveshow">按鈕</el-button>
      <transition enter-active-class="animate__animated animate__fadeInUp" >
        <div v-show="activeObserveshow">文字</div>
      </transition>

      <swiper :options="swiperOptions">
        <swiper-slide>Slide 1</swiper-slide>
        <swiper-slide>Slide 2</swiper-slide>
        <swiper-slide>Slide 3</swiper-slide>
        <swiper-slide>Slide 4</swiper-slide>
        <swiper-slide>Slide 5</swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import 'fullpage.js/dist/fullpage.css';
import 'fullpage.js';
import { getLogin } from '@/api/index.js'
export default {
  name: "Index",
  data() {
    return {
      loginForm: {
        account: JSON.parse(window.localStorage.getItem('objlogin')) ? JSON.parse(window.localStorage.getItem('objlogin')).account : '',
        password: JSON.parse(window.localStorage.getItem('objlogin')) ? JSON.parse(window.localStorage.getItem('objlogin')).password : ''
      },
      informationVisible: false,
      capsTooltip: false,
      loading: false,
      passwordType: 'password',
      activeObserveshow: true,
      swiperOptions: {},
      checked: !!JSON.parse(window.localStorage.getItem('objlogin')),
    }
  },
  created() {

  },
  mounted() {
    // 初始化fullpage插件
    $(this.$refs.fullpage).fullpage({
      // fullPage.js options go here
      navigation: true,
      scrollOverflow:true,
      resize:false,
      // sectionsColor: ['#f00', '#f66', '#f88', '#f99'],
      // anchors: ['sec1', 'section2', 'section3', 'section4', 'section5', 'section6', 'section7'],
      // normalScrollElements: '.scrollBoyd .body',
      // onLeave: function (index, nextIndex, direction) {
      // },
      // afterLoad: function (anchorLink, index) {
      // },
      // afterRender: function () {
      // },
    });
  },
  beforeDestroy() {
    // 在组件销毁之前销毁fullPage.js实例，以避免内存泄漏
    // $(this.$refs.fullpage).fullpage.destroy('all');
    $.fn.fullpage.destroy('all');
  },
  methods:{
    checkCapslock(e) {
      const { key } = e
      this.capsTooltip = key && key.length === 1 && (key >= 'A' && key <= 'Z')
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      getLogin(this.loginForm).then(res =>{
         if(res.code == 200){
            if(this.checked){
               window.localStorage.setItem('objlogin',JSON.stringify(this.loginForm))
            }
           window.localStorage.setItem('agency_info',JSON.stringify(res.data.agency_info))
           window.localStorage.setItem('token',res.data.token_info.token)
           this.$store.dispatch('user/getInfo')
           this.$router.push('/');
         }else{
            this.$message.warning(res.message)
         }
      })

    }
  }
};
</script>

<style lang="scss" scoped>
.home {

}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label{
  color: #FFFFFF !important;
}
::v-deep .el-input .el-input__clear{
  color: #FFFFFF !important;
}
</style>
